module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-campaign-header-bg-8c117c5453c0e02f7953b1669842f5ff.png";